import React, { useMemo } from 'react';
import NavigationItem from './NavigationItem';
import NavigationItemMobile from './NavigationItemMobile';
import { useSelector } from 'react-redux';
import { MegaMenuVisibility } from '../constants';

const Navigation = ({ itemType }) => {
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const excluded =
        itemType === 'mobile'
            ? MegaMenuVisibility.DesktopOnly
            : MegaMenuVisibility.MobileOnly;
    const filtered = useMemo(
        () => (contentLinks || []).filter((link) => link.visibility !== excluded),
        [contentLinks, excluded]
    );

    if (itemType === 'mobile') {
        return <NavigationItemMobile links={filtered} />;
    }

    return <NavigationItem links={filtered} />;
};

export default Navigation;